// bitwise flags
const PATIENT_PARAMETER_BITS = {
  ecg: 1,
  spo2: 2,
  temp: 4,
  nibp: 8,
  cnap: 16,
  ibp: 32,
  co: 64,
  bis: 128,
  eeg: 256,
  nmt: 512,
  etco2: 1024,
  coo: 2048,
};

const PARAMETER_OPTIONS = [
  "3-lead (iec1 europe)",
  "3-lead (iec2 aha/us)",
  "4-lead (iec1 europe)",
  "4-lead (iec2 aha/us)",
  "5-lead (iec1 europe)",
  "5-lead (iec2 aha/us)",
  "6-lead (iec1 europe)",
  "6-lead (iec2 aha/us)",
  "12-lead (iec1 europe)",
  "12-lead (iec2 aha/us)",
  "draeger",
  "nellcor",
  "skin probe",
  "general-purpose probe",
  "t-core",
  "masimo",
  "masimo_us",
  "dräger smart pod connection",
  "sidestream",
  "scio",
  "dräger monitor connection",
  "mainstream",
  "oral probe",
  "rectal probe",
  "scanner",
  "suntech",
];
const PARAMETER_OPTION_BITS = PARAMETER_OPTIONS.reduce((acc, option, idx) => {
  acc[option] = 1 << idx;
  return acc;
}, {});

const PATIENT_CATEGORY_BITS = {
  adult: 1,
  pediatric: 2,
  neonatal: 4,
};

const USAGE_CATEGORY_BITS = {
  reusable: 1,
  disposable: 2,
};

const MONITOR_BITS = {
  "delta-xl": 1,
  "kappa-xlt": 2,
  "gamma-x-xl": 4,
  "gamma-xl": 8,
  "vista-xl": 16,
  vista: 32,
  m540: 64,
  "acute-care-system": 128,
  "m300-plus": 256,
  "vista-120-s": 512, // not used in Phase 2
  "vista-120-s-a": 1024,
  "vista-120-s-c": 2048,
  "vista-120-a": 4096,
  "vista-120-c": 8192,
  "vista-120-sc-a": 16384,
  "vista-120-sc-b": 32768,
  "vista-120-sc-c": 65536,
  "vista-120-sc-d": 131072,
  "vista-120-sc-e": 262144,
  "vista-300": 524288,
  "vista-t100": 1048576,
  "vista-t100-s": 2097152,
};

module.exports = {
  PATIENT_PARAMETER_BITS,
  PARAMETER_OPTION_BITS,
  PATIENT_CATEGORY_BITS,
  USAGE_CATEGORY_BITS,
  MONITOR_BITS,
};
